
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'

import config from '@/config/index'
import { getOrderDetail, confirmGoods } from '@/api/youzheng.js'
import errorImg from '@/assets/mall/img-error.png'
import Storage from '@/storage'
export default {
name: 'orderdetail',
components: {
Flexbox,
FlexboxItem,
Cell,
Group
},
data () {
return {
baseUrl: config.baseUrl,
errorImg: errorImg,
orderid: this.$route.params.id,
openid: Storage.get('openId'),
orderObj: {}
}
},
created () {
this.getDetail()
},
computed: {
accountid () {
return this.$store.state.user.ID
},
userid () {
return this.$store.state.user.userid
}
},
methods: {
onImgError ($event) {
$event.target.src = this.errorImg
},
getDetail () {
getOrderDetail({
orderid: this.orderid,
accountid: this.accountid,
openid: this.openid
}).then(data => {
this.orderObj = data.returnValue
})
},

godetail (id) {
this.$router.push({ name: 'mall2ProductDetail', params: { id: id } })
},
complaint (productid, orderid) {
this.$router.push({ name: 'mall2complaint', params: { id: productid, orderid: orderid } })
},
examine (id) {
this.$router.push({ name: 'mall2logistics', params: { orderid: id } })
},
evaluate (id) {
this.$router.push({ name: 'mall2evaluate', params: { orderid: id } })
},
certain (id) {
var _this = this
this.$vux.confirm.show({
content: '请确认您已经收到商品！',
onConfirm () {
confirmGoods({
userid: _this.userid,
accountid: _this.accountid,
orderid: id
}).then(res => {
_this.getDetail()
if (res.success) {
_this.$vux.alert.show({
content: '确认收货成功',
onHide () {

}
})
}
})
}
})
}
}
}
